import {isFirstLine, isSingleCursor, selectedTypesOnlyAllowed, previousLineRange} from '../state.js';
import {changeByRangeTrimmedBlock, insertSelected} from './changes.js';
import {wholeLineWithOptionalNewline} from './topLevel.js';
import {blank} from "./trim.js";

export function canAddList({state}) {
  return selectedTypesOnlyAllowed(state, ['Paragraph']) && wholeLineWithOptionalNewline(state);
}

export function addUnorderedList(placeholder) {
  return addList(() => '- ', placeholder);
}

export function addOrderedList(placeholder) {
  let listIndex = 1;
  return addList(() => listIndex++ + '. ', placeholder);
}

function addList(listMarkerGen, placeholder) {
  return ({state, dispatch}) => {
    if (canAddList({state})) {
      dispatch({...addListCommand(state, listMarkerGen, placeholder), userEvent: 'input.addList'});
    }
  };
}

function addListCommand(state, listMarkerGenerator, placeholder) {
  const padding = listPadding(state);
  if (isSingleCursor(state)) {
    return insertSelected(state, padding + listMarkerGenerator(), placeholder, '\n');
  }
  return changeByRangeTrimmedBlock(state, text => padding + listMarkdown(text, listMarkerGenerator) + '\n');
}

function listMarkdown(string, listMarkerGen) {
  return string
    .split("\n")
    .map(line => listMarkerGen() + line)
    .join("\n");
}

function listPadding(state) {
  if (listNeedsPadding(state, state.selection.main.from)) {
    return '\n';
  }
  return '';
}

function listNeedsPadding(state, from) {
  if (isFirstLine(state, from)) {
    return selectionStartsAtTheEndOfLine(state, from);
  }
  return !rangeBlank(state, previousLineRange(state, from));
}

function rangeBlank(state, {from, to}) {
  return blank(state.sliceDoc(from, to));
}

function selectionStartsAtTheEndOfLine(state, from) {
  const line = state.doc.lineAt(from);
  if (line.to === from) {
    return line.from !== from;
  }
  return false;
}
